import React, { useEffect } from "react";

import "./portal.scss";

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome: React.FC = () => {
  const [tabIndex, setTabIndex] = React.useState<string>("home");

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: "Walter White",
      consultorio: "Av. Spinetto 670, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-123456",
      matricula: "1234",
      cuit: "20-12345678-9",
      especialidades: ["Fonoaudiología", "Audiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    {
      nombre: "Sarah Jhonson",
      consultorio: "Belgrano 123, General Pico",
      localidad: "General Pico",
      telefono: "2954-654321",
      matricula: "5678",
      cuit: "27-87654321-0",
      especialidades: ["Voz", "Lenguaje"],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: "William Anderson",
      consultorio: "Rivadavia 456, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-789012",
      matricula: "9101",
      cuit: "23-11223344-5",
      especialidades: ["Odontoesmatología", "Deglución"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    {
      nombre: "Amanda Jepson",
      consultorio: "San Martín 789, Toay",
      localidad: "Toay",
      telefono: "2954-345678",
      matricula: "1121",
      cuit: "27-55667788-1",
      especialidades: ["Rehabilitación", "Audiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: "Lucía Fernández",
      consultorio: "Av. Luro 1500, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-111222",
      matricula: "2233",
      cuit: "27-33445566-2",
      especialidades: ["Lenguaje", "Fonoaudiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "https://facebook.com/luciaf",
        instagram: "https://instagram.com/luciaf",
        linkedin: "",
      },
    },
    {
      nombre: "Martín Gómez",
      consultorio: "Calle 9 N° 456, General Pico",
      localidad: "General Pico",
      telefono: "2954-333444",
      matricula: "3344",
      cuit: "20-99887766-3",
      especialidades: ["Audiología"],
      atiendeObraSocial: false,
      redes: {
        twitter: "https://twitter.com/mgomez",
        facebook: "",
        instagram: "",
        linkedin: "https://linkedin.com/in/mgomez",
      },
    },
    {
      nombre: "Paula Sosa",
      consultorio: "Av. Perón 234, Toay",
      localidad: "Toay",
      telefono: "2954-555666",
      matricula: "4455",
      cuit: "23-44556677-8",
      especialidades: ["Voz", "Rehabilitación"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "",
        instagram: "https://instagram.com/paulasosa",
        linkedin: "",
      },
    },
    {
      nombre: "Federico Ruiz",
      consultorio: "Mitre 800, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-777888",
      matricula: "5566",
      cuit: "20-22334455-6",
      especialidades: ["Odontoesmatología", "Lenguaje", "Deglución"],
      atiendeObraSocial: false,
      redes: {
        twitter: "https://twitter.com/federicoruiz",
        facebook: "",
        instagram: "",
        linkedin: "",
      },
    },
    {
      nombre: "María López",
      consultorio: "Calle 25 N° 100, General Pico",
      localidad: "General Pico",
      telefono: "2954-999000",
      matricula: "6677",
      cuit: "27-77889900-1",
      especialidades: ["Fonoaudiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "https://facebook.com/marialopez",
        instagram: "",
        linkedin: "",
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState("");
  const [filtroLocalidad, setFiltroLocalidad] = React.useState("");
  const [filtroObraSocial, setFiltroObraSocial] = React.useState("");
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState("");

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(
    new Set(profesionalesData.map((p) => p.localidad))
  );
  const especialidades = Array.from(
    new Set(profesionalesData.flatMap((p) => p.especialidades))
  );

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter((p) => {
    const matchNombre =
      p.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) ||
      p.matricula.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === "si" && p.atiendeObraSocial) ||
      (filtroObraSocial === "no" && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return (
      matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad
    );
  });

  useEffect(() => {
    if (tabIndex === "institucional" && window.PureCounter) {
      new window.PureCounter();
    }
  }, [tabIndex]);

  useEffect(() => {
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      "./assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js",
      "./assets/portal/vendor/php-email-form/validate.js",
      "./assets/portal/vendor/aos/aos.js",
      "./assets/portal/vendor/glightbox/js/glightbox.min.js",
      "./assets/portal/vendor/purecounter/purecounter_vanilla.js",
      "./assets/portal/js/main.js",
    ];
    const scriptElements = scripts.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: "https://fonts.googleapis.com", rel: "preconnect" },
      {
        href: "https://fonts.gstatic.com",
        rel: "preconnect",
        crossorigin: "anonymous",
      },
      {
        href: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
        rel: "stylesheet",
      },
    ];
    const linkElements = fontLinks.map((props) => {
      const link = document.createElement("link");
      Object.entries(props).forEach(([key, value]) =>
        link.setAttribute(key, value)
      );
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      "/assets/portal/vendor/bootstrap/css/bootstrap.min.css",
      "/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css",
      "/assets/portal/vendor/aos/aos.css",
      "/assets/portal/vendor/fontawesome-free/css/all.min.css",
      "/assets/portal/vendor/glightbox/css/glightbox.min.css",
      "/assets/portal/vendor/swiper/swiper-bundle.min.css",
      "/assets/portal/css/main.css",
    ];
    const cssElements = cssLinks.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach((script) => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach((link) => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach((link) => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER */}
      <header id="header" className="header sticky-top">
        <div
          className="topbar d-flex align-items-center"
          style={{
            background:
              "linear-gradient(135deg, rgba(71, 85, 105, 0.95) 0%, rgba(100, 116, 139, 0.95) 50%, rgba(51, 65, 85, 0.95) 100%)",
            backdropFilter: "blur(10px)",
            borderBottom: "1px solid rgba(148, 163, 184, 0.3)",
            boxShadow: "0 2px 20px rgba(71, 85, 105, 0.25)",
            padding: "10px 0",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Elemento decorativo de fondo */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: `
              radial-gradient(circle at 20% 50%, rgba(148, 163, 184, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(71, 85, 105, 0.15) 0%, transparent 50%)
            `,
              zIndex: 1,
            }}
          />

          <div
            className="container d-flex justify-content-center justify-content-md-between"
            style={{
              position: "relative",
              zIndex: 2,
            }}
          >
            <div
              className="d-none d-md-flex align-items-center"
              style={{
                color: "#ffffff",
                fontSize: "0.9rem",
                fontWeight: "500",
                fontFamily: "'Poppins', sans-serif",
                textShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                letterSpacing: "0.3px",
              }}
            >
              <i
                className="bi bi-building me-2"
                style={{
                  fontSize: "1rem",
                  color: "#64748b",
                }}
              ></i>
              Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <a
              href="https://wa.me/5429542954702284?text=Hola,%20necesito%20información%20sobre%20los%20servicios%20del%20Colegio%20de%20Fonoaudiólogos"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{
                color: "#ffffff",
                fontSize: "0.9rem",
                fontWeight: "500",
                fontFamily: "'Poppins', sans-serif",
                textShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                letterSpacing: "0.3px",
                textDecoration: "none",
                transition: "all 0.3s ease",
                padding: "5px 10px",
                borderRadius: "25px",
                backgroundColor: "rgba(100, 116, 139, 0.2)",
                backdropFilter: "blur(5px)",
                border: "1px solid rgba(148, 163, 184, 0.4)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(71, 85, 105, 0.3)";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 5px 15px rgba(71, 85, 105, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(100, 116, 139, 0.2)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="bi bi-whatsapp me-2"
                style={{
                  fontSize: "1rem",
                  color: "#25d366",
                  animation: "topbarPulse 2s infinite",
                }}
              ></i>
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a
              href="index.html"
              className="logo d-flex align-items-center me-auto"
            >
              <img src="assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li>
                  <a
                    href="#"
                    className="active"
                    onClick={() => setTabIndex("home")}
                  >
                    Inicio
                  </a>
                </li>
                <li className="dropdown">
                  <a href="#" onClick={() => setTabIndex("institucional")}>
                    <span>Institucional</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Quiénes somos?
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Comisión Directiva
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Tribunal de Etica y Disciplina
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Comisión Revisora de Cuentas
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a href="#" onClick={() => setTabIndex("tramites")}>
                    <span>Trámites</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#" onClick={() => setTabIndex("matriculacion")}>
                        Matriculación
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("consultorio")}>
                        Consultorio
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("tramites")}>
                        Título
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("tramites")}>
                        Baja de Matrícula
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Habilitación de Consultorio
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a
                    href="#"
                    onClick={() => setTabIndex("ejercicio-profesional")}
                  >
                    <span>Ejercicio Profesional</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Honorarios Mínimos
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Código de ética
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("certificado-etica")}
                      >
                        Certificado de ética
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Consentimiento informado
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Habilitación de Consultorio
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#" onClick={() => setTabIndex("profesionales")}>
                    Profesionales
                  </a>
                </li>
                <li>
                  <a href="#">Obras Sociales</a>
                </li>
                <li>
                  <a href="#" onClick={() => setTabIndex("contacto")}>
                    Contacto
                  </a>
                </li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a
              className="cta-btn"
              href="http://145.223.94.120/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AUTOGESTION
            </a>
          </div>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === "home" && (
          <>
            <section
              id="hero"
              className="hero section"
              style={{
                position: "relative",
                height: "400px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  "linear-gradient(135deg, #475569 0%, #64748b 25%, #334155 50%, #94a3b8 75%, #475569 100%)",
                backgroundSize: "400% 400%",
                animation: "gradientShift 15s ease infinite",
                overflow: "hidden",
              }}
            >
              {/* Elementos de fondo modernos */}

              {/* Ondas animadas de fondo */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `
                  radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 75% 75%, rgba(71, 85, 105, 0.15) 0%, transparent 50%),
                  radial-gradient(circle at 50% 50%, rgba(100, 116, 139, 0.1) 0%, transparent 50%)
                `,
                  zIndex: 1,
                }}
              />

              {/* Patrón geométrico animado */}
              <div
                style={{
                  position: "absolute",
                  top: "-50%",
                  left: "-50%",
                  width: "200%",
                  height: "200%",
                  backgroundImage: `
                  linear-gradient(45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(-45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%),
                  linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%)
                `,
                  backgroundSize: "60px 60px",
                  backgroundPosition: "0 0, 0 30px, 30px -30px, -30px 0px",
                  animation: "patternFloat 20s linear infinite",
                  zIndex: 2,
                }}
              />

              {/* Círculos flotantes */}
              <div
                style={{
                  position: "absolute",
                  top: "10%",
                  right: "15%",
                  width: "300px",
                  height: "300px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(71, 85, 105, 0.15))",
                  backdropFilter: "blur(10px)",
                  animation: "floatUpDown 6s ease-in-out infinite",
                  zIndex: 2,
                }}
              />

              <div
                style={{
                  position: "absolute",
                  bottom: "10%",
                  left: "10%",
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, rgba(100, 116, 139, 0.15), rgba(51, 65, 85, 0.15))",
                  backdropFilter: "blur(10px)",
                  animation: "floatUpDown 8s ease-in-out infinite reverse",
                  zIndex: 2,
                }}
              />

              {/* Triángulos decorativos */}
              <div
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "5%",
                  width: "100px",
                  height: "100px",
                  background:
                    "linear-gradient(45deg, rgba(255, 255, 255, 0.1), transparent)",
                  clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                  animation: "rotateFloat 12s linear infinite",
                  zIndex: 2,
                }}
              />

              <div
                style={{
                  position: "absolute",
                  bottom: "15%",
                  right: "8%",
                  width: "80px",
                  height: "80px",
                  background:
                    "linear-gradient(45deg, rgba(51, 65, 85, 0.2), transparent)",
                  clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                  animation: "rotateFloat 10s linear infinite reverse",
                  zIndex: 2,
                }}
              />

              {/* Overlay principal con textura */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `
                  linear-gradient(135deg, 
                    rgba(71, 85, 105, 0.85) 0%, 
                    rgba(100, 116, 139, 0.75) 25%,
                    rgba(51, 65, 85, 0.8) 50%,
                    rgba(148, 163, 184, 0.7) 75%,
                    rgba(71, 85, 105, 0.85) 100%
                  )
                `,
                  backdropFilter: "blur(1px)",
                  zIndex: 3,
                }}
              />

              {/* Contenido principal */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "relative",
                  zIndex: 4,
                  padding: "60px 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "55%",
                    height: "auto",
                    position: "relative",
                    overflow: "visible",
                  }}
                >
                  <video
                    autoPlay
                    muted
                    loop={false}
                    playsInline
                    style={{
                      width: "1600px",
                      height: "auto",
                      objectFit: "contain",
                      opacity: 0,
                      transform: "translateY(20px)",
                      animation: "scaleIn 1s ease-out 0.3s forwards",
                    }}
                    onLoadedData={(e) => {
                      // Asegurar que el video se reproduzca
                      e.currentTarget.play().catch(() => {
                        // Si autoplay falla, al menos mostrar el primer frame
                        e.currentTarget.currentTime = 0;
                      });
                    }}
                  >
                    <source
                      src="./assets/portal/img/logo_banner.webm"
                      type="video/webm"
                    />
                    {/* Fallback para navegadores que no soporten webm */}
                    <img
                      src="./assets/img/logo-cofolp.png"
                      alt="Logo COFOLP"
                      style={{
                        width: "auto",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: "280px",
                        objectFit: "contain",
                      }}
                    />
                  </video>
                </div>
              </div>
              <style>{`
                /* Animación actual: fadeInUp */
                @keyframes scaleIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }

                @keyframes fadeInUp {
                  0% {
                    opacity: 0;
                    transform: translateY(20px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
                
                /* Nueva animación simplificada para los logos */
                @keyframes logoEntrance {
                  0% {
                    opacity: 0;
                    transform: translateY(15px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
                
                
                
                /* Animación para el banner de texto */
                @keyframes slideInUp {
                  0% {
                    opacity: 0;
                    transform: translateY(30px) scale(0.95);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                /* Animación 2: fadeInLeft - aparece desde la izquierda */
                @keyframes fadeInLeft {
                  0% {
                    opacity: 0;
                    transform: translateX(-30px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                }
                
                /* Animación 3: scaleIn - aparece creciendo desde el centro */
                @keyframes scaleIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
                
                /* Animación 4: bounceIn - efecto rebote */
                @keyframes bounceIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.3);
                  }
                  50% {
                    opacity: 1;
                    transform: scale(1.05);
                  }
                  70% {
                    transform: scale(0.9);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
                
                /* Animación 5: slideInRight - desliza desde la derecha */
                @keyframes slideInRight {
                  0% {
                    opacity: 0;
                    transform: translateX(30px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                }
                
                /* Animación 6: flipIn - efecto de volteo */
                @keyframes flipIn {
                  0% {
                    opacity: 0;
                    transform: rotateY(-90deg);
                  }
                  100% {
                    opacity: 1;
                    transform: rotateY(0);
                  }
                }
                
                /* Nuevas animaciones para el fondo moderno */
                @keyframes gradientShift {
                  0% {
                    background-position: 0% 50%;
                  }
                  25% {
                    background-position: 50% 25%;
                  }
                  50% {
                    background-position: 100% 50%;
                  }
                  75% {
                    background-position: 50% 75%;
                  }
                  100% {
                    background-position: 0% 50%;
                  }
                }
                
                /* Animación para la topbar */
                @keyframes topbarPulse {
                  0%, 100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                  50% {
                    opacity: 0.8;
                    transform: scale(1.05);
                  }
                }
                
                @keyframes patternFloat {
                  0% {
                    transform: translateX(0) translateY(0) rotate(0deg);
                  }
                  25% {
                    transform: translateX(-10px) translateY(-15px) rotate(90deg);
                  }
                  50% {
                    transform: translateX(0) translateY(-30px) rotate(180deg);
                  }
                  75% {
                    transform: translateX(10px) translateY(-15px) rotate(270deg);
                  }
                  100% {
                    transform: translateX(0) translateY(0) rotate(360deg);
                  }
                }
                
                @keyframes floatUpDown {
                  0%, 100% {
                    transform: translateY(0px);
                  }
                  50% {
                    transform: translateY(-20px);
                  }
                }
                
                @keyframes rotateFloat {
                  0% {
                    transform: rotate(0deg) translateY(0px);
                  }
                  50% {
                    transform: rotate(180deg) translateY(-15px);
                  }
                  100% {
                    transform: rotate(360deg) translateY(0px);
                  }
                }
                
                /* Responsive para el nuevo banner */
                @media (max-width: 768px) {
                  /* Topbar responsive */
                  .topbar {
                    padding: 8px 0 !important;
                    font-size: 0.8rem !important;
                  }
                  
                  .topbar .container > div {
                    font-size: 0.85rem !important;
                  }
                  
                  #hero {
                    min-height: 400px !important;
                    padding: 40px 0 !important;
                  }
                  
                  /* Ocultar el banner de texto en móviles */
                  .banner-text {
                    display: none !important;
                  }
                  
                  /* Contenedor principal en móviles - centrado */
                  #hero > div:last-child {
                    justify-content: center !important;
                  }
                  
                  /* Logos responsive - contenedor principal */
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    flex-direction: column !important;
                    gap: 15px !important;
                    padding: 0 20px !important;
                    max-width: none !important;
                    justify-content: center !important;
                    align-items: center !important;
                  }
                  
                  /* Ocultar logo_1 en tablets */
                  .logo-1 {
                    display: none !important;
                  }
                  
                  /* Imágenes de logos - solo logo_2 visible */
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 160px !important;
                    max-width: 95% !important;
                    object-fit: contain !important;
                  }
                  
                  /* Elementos decorativos responsive */
                  #hero > div:nth-child(3) {
                    width: 200px !important;
                    height: 200px !important;
                  }
                  #hero > div:nth-child(4) {
                    width: 150px !important;
                    height: 150px !important;
                  }
                }
                
                @media (max-width: 600px) {
                  #hero {
                    min-height: 350px !important;
                    padding: 30px 0 !important;
                  }
                  
                  /* Ocultar banner de texto */
                  .banner-text {
                    display: none !important;
                  }
                  
                  /* Contenedor principal centrado */
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 15px !important;
                  }
                  
                  /* Contenedor de logos */
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    padding-left: 15px !important;
                    gap: 12px !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  /* Ocultar logo_1 completamente */
                  .logo-1 {
                    display: none !important;
                  }
                  
                  /* Ajustar logo_2 para pantallas medianas - centrado perfecto */
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 130px !important;
                    max-width: 90% !important;
                    object-fit: contain !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                }
                
                @media (max-width: 480px) {
                  #hero {
                    min-height: 320px !important;
                    padding: 20px 0 !important;
                  }
                  
                  /* Ocultar banner de texto en móviles */
                  .banner-text {
                    display: none !important;
                  }
                  
                  /* Ocultar elementos decorativos complejos en móviles pequeños */
                  .banner-deco {
                    display: none !important;
                  }
                  
                  /* Contenedor principal centrado */
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 10px !important;
                  }
                  
                  /* Contenedor de logos */
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    gap: 10px !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  /* Ocultar logo_1 completamente en móviles */
                  .logo-1 {
                    display: none !important;
                  }
                  
                  /* Solo mostrar logo_2 centrado - más pequeño para móviles */
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 110px !important;
                    max-width: 90% !important;
                    object-fit: contain !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                  
                  /* Ocultar algunos elementos decorativos en móvil */
                  #hero > div:nth-child(5),
                  #hero > div:nth-child(6),
                  #hero > div:nth-child(7) {
                    display: none !important;
                  }
                  
                  /* Simplificar animaciones en móviles para mejor rendimiento */
                  #hero > div:nth-child(2) {
                    animation: none !important;
                  }
                }
              `}</style>
              <div
                className="banner-text"
                style={{
                  width: "100%",
                  height: "auto",
                  // maxWidth: "600px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // padding: "40px 30px",
                  margin: 0,
                  textAlign: "center",
                  position: "absolute",
                  // left: "50%",
                  bottom: 0,
                  transform: "translate(-50%, 50%)",
                  zIndex: 10,
                  // ...resto de estilos visuales...
                  opacity: 0,
                  animation: "slideInUp 1.2s ease-out 4s forwards",
                }}
              >
                {/* Contenido del texto */}
                <div style={{ position: "relative", zIndex: 2 }}>
                  <div
                    style={{
                      color: "rgb(164 164 163)",
                      fontSize: "1.3rem",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      textShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                      margin: 0,
                      fontFamily: "'Poppins', sans-serif",
                      letterSpacing: "-0.5px",
                      marginBottom: "12px",
                    }}
                  >
                    El respaldo de la Fonoaudiología en La Pampa
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "500",
                        color: "rgba(255, 255, 255, 0.95)",
                        margin: 0,
                        fontFamily: "'Poppins', sans-serif",
                        letterSpacing: "0.3px",
                        textShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                        marginLeft: "20px",
                      }}
                    >
                      Regulación • Formación • Ética
                    </span>
                  </div>

                  {/* <div
                      style={{
                        width: "60px",
                        height: "3px",
                        background: "linear-gradient(90deg, #94a3b8, #64748b)",
                        margin: "5px auto",
                        borderRadius: "2px",
                      }}
                    /> */}
                </div>
              </div>
            </section>
            {/* Hero Section */}

            {/* Featured Services Section */}
            <section
              id="featured-services"
              className="featured-services section"
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                padding: "40px 0",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Elementos decorativos de fondo */}
              <div
                style={{
                  position: "absolute",
                  top: "-50px",
                  right: "-50px",
                  width: "300px",
                  height: "300px",
                  background:
                    "linear-gradient(135deg, rgba(71, 85, 105, 0.1), rgba(100, 116, 139, 0.1))",
                  borderRadius: "50%",
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "-100px",
                  left: "-100px",
                  width: "400px",
                  height: "400px",
                  background:
                    "linear-gradient(135deg, rgba(100, 116, 139, 0.1), rgba(51, 65, 85, 0.1))",
                  borderRadius: "50%",
                  zIndex: 1,
                }}
              />

              <div
                className="container"
                style={{ position: "relative", zIndex: 2 }}
              >
                {/* Título de la sección */}
                {/* <div iv> */}

                <div className="row gy-4 justify-content-center">
                  {/* Servicio 1: Acceso a AUTOGESTION */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div
                      className="modern-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.15) 100%)",
                        backdropFilter: "blur(10px)",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        textAlign: "center",
                        border: "1px solid rgba(59, 130, 246, 0.3)",
                        boxShadow: "0 20px 40px rgba(59, 130, 246, 0.1)",
                        transition:
                          "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "320px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-10px) scale(1.02)";
                        e.currentTarget.style.boxShadow =
                          "0 30px 60px rgba(59, 130, 246, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(59, 130, 246, 0.1)";
                      }}
                      onClick={() =>
                        window.open("http://145.223.94.120/", "_blank")
                      }
                    >
                      {/* Elemento decorativo */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-20px",
                          right: "-20px",
                          width: "100px",
                          height: "100px",
                          background:
                            "linear-gradient(45deg, rgba(59, 130, 246, 0.25), transparent)",
                          borderRadius: "50%",
                          zIndex: 1,
                        }}
                      />

                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="service-icon"
                          style={{
                            width: "80px",
                            height: "80px",
                            background:
                              "linear-gradient(135deg, #3b82f6, #2563eb)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 10px 30px rgba(59, 130, 246, 0.4)",
                          }}
                        >
                          <i
                            className="fas fa-laptop-code"
                            style={{
                              fontSize: "2rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.4rem",
                            fontWeight: "600",
                            color: "#1e293b",
                            marginBottom: "15px",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Acceso a AUTOGESTION
                        </h4>

                        <p
                          style={{
                            color: "#64748b",
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Gestione sus trámites, consulte su estado de cuenta y
                          acceda a todos los servicios digitales del colegio.
                        </p>

                        <div
                          style={{
                            marginTop: "20px",
                            padding: "10px 20px",
                            background:
                              "linear-gradient(90deg, #3b82f6, #2563eb)",
                            color: "white",
                            borderRadius: "25px",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            display: "inline-block",
                          }}
                        >
                          Ingresar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 2: Buscar Fonoaudiólogo */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div
                      className="modern-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(5, 150, 105, 0.15) 0%, rgba(16, 185, 129, 0.15) 100%)",
                        backdropFilter: "blur(10px)",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        textAlign: "center",
                        border: "1px solid rgba(34, 197, 94, 0.3)",
                        boxShadow: "0 20px 40px rgba(5, 150, 105, 0.1)",
                        transition:
                          "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "320px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-10px) scale(1.02)";
                        e.currentTarget.style.boxShadow =
                          "0 30px 60px rgba(5, 150, 105, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(5, 150, 105, 0.1)";
                      }}
                      onClick={() => setTabIndex("profesionales")}
                    >
                      {/* Elemento decorativo */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-20px",
                          right: "-20px",
                          width: "100px",
                          height: "100px",
                          background:
                            "linear-gradient(45deg, rgba(5, 150, 105, 0.25), transparent)",
                          borderRadius: "50%",
                          zIndex: 1,
                        }}
                      />

                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="service-icon"
                          style={{
                            width: "80px",
                            height: "80px",
                            background:
                              "linear-gradient(135deg, #059669, #047857)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 10px 30px rgba(5, 150, 105, 0.4)",
                          }}
                        >
                          <i
                            className="fas fa-user-md"
                            style={{
                              fontSize: "2rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.4rem",
                            fontWeight: "600",
                            color: "#1e293b",
                            marginBottom: "15px",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Buscar Fonoaudiólogo
                        </h4>

                        <p
                          style={{
                            color: "#64748b",
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Encuentre profesionales matriculados por especialidad,
                          localidad y cobertura de obra social.
                        </p>

                        <div
                          style={{
                            marginTop: "20px",
                            padding: "10px 20px",
                            background:
                              "linear-gradient(90deg, #059669, #047857)",
                            color: "white",
                            borderRadius: "25px",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            display: "inline-block",
                          }}
                        >
                          Buscar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 3: Próximos Cursos y Eventos */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div
                      className="modern-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(249, 115, 22, 0.15) 0%, rgba(234, 88, 12, 0.15) 100%)",
                        backdropFilter: "blur(10px)",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        textAlign: "center",
                        border: "1px solid rgba(249, 115, 22, 0.3)",
                        boxShadow: "0 20px 40px rgba(249, 115, 22, 0.1)",
                        transition:
                          "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "320px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-10px) scale(1.02)";
                        e.currentTarget.style.boxShadow =
                          "0 30px 60px rgba(249, 115, 22, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(249, 115, 22, 0.1)";
                      }}
                      onClick={() => {
                        // Por ahora solo mostramos alerta, luego se puede implementar navegación
                        alert(
                          "Sección de Cursos y Eventos próximamente disponible"
                        );
                      }}
                    >
                      {/* Elemento decorativo */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-20px",
                          right: "-20px",
                          width: "100px",
                          height: "100px",
                          background:
                            "linear-gradient(45deg, rgba(249, 115, 22, 0.25), transparent)",
                          borderRadius: "50%",
                          zIndex: 1,
                        }}
                      />

                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="service-icon"
                          style={{
                            width: "80px",
                            height: "80px",
                            background:
                              "linear-gradient(135deg, #f97316, #ea580c)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 10px 30px rgba(249, 115, 22, 0.4)",
                          }}
                        >
                          <i
                            className="fas fa-calendar-alt"
                            style={{
                              fontSize: "2rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.4rem",
                            fontWeight: "600",
                            color: "#1e293b",
                            marginBottom: "15px",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Próximos Cursos y Eventos
                        </h4>

                        <p
                          style={{
                            color: "#64748b",
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Manténgase actualizado con las últimas capacitaciones,
                          workshops y eventos del colegio.
                        </p>

                        <div
                          style={{
                            marginTop: "20px",
                            padding: "10px 20px",
                            background:
                              "linear-gradient(90deg, #f97316, #ea580c)",
                            color: "white",
                            borderRadius: "25px",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            display: "inline-block",
                          }}
                        >
                          Ver Eventos →
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Estilos CSS adicionales */}
              <style>{`
                .modern-service-card:hover .service-icon {
                  transform: scale(1.1) rotate(5deg);
                  transition: all 0.3s ease;
                }
                
                @media (max-width: 768px) {
                  .modern-service-card {
                    min-height: 280px !important;
                    padding: 30px 20px !important;
                  }
                  
                  .modern-service-card h4 {
                    font-size: 1.2rem !important;
                  }
                  
                  .service-icon {
                    width: 70px !important;
                    height: 70px !important;
                  }
                  
                  .service-icon i {
                    font-size: 1.7rem !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .modern-service-card {
                    margin: 10px !important;
                    min-height: 260px !important;
                  }
                }
              `}</style>
            </section>
          </>
        )}

        {tabIndex === "institucional" && (
          <>
            {/* Stats Section */}
            <section id="stats" className="stats section">
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="row gy-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-user-md flex-shrink-0"></i>
                      <div>
                        <span
                          data-purecounter-start="0"
                          data-purecounter-end="250"
                          data-purecounter-duration="1"
                          className="purecounter"
                        ></span>
                        <p>Profesionales</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="far fa-hospital flex-shrink-0"></i>
                      <div>
                        <span
                          data-purecounter-start="0"
                          data-purecounter-end="145"
                          data-purecounter-duration="1"
                          className="purecounter"
                        ></span>
                        <p>Consultorios</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-newspaper flex-shrink-0"></i>
                      <div>
                        <span
                          data-purecounter-start="0"
                          data-purecounter-end="32"
                          data-purecounter-duration="1"
                          className="purecounter"
                        ></span>
                        <p>Convenios Obra Social Vigentes</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-flask flex-shrink-0"></i>
                      <div>
                        <span
                          data-purecounter-start="0"
                          data-purecounter-end="24"
                          data-purecounter-duration="1"
                          className="purecounter"
                        ></span>
                        <p>Info</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "matriculacion" && (
          <>
            {/* Matriculación Section */}
            <section id="matriculacion" className="about section">
              <div className="container section-title" data-aos="fade-up">
                <h2>
                  Matriculación
                  <br />
                </h2>
                <p>
                  Lea atentamente los requisitos necesarios para incorporarse
                  como un nuevo profesional en el Colegio de Fonoaudiólogos de
                  La Pampa.
                </p>
              </div>

              <div className="container">
                <div className="row gy-4">
                  <div
                    className="col-lg-6 position-relative align-self-start"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <img
                      src="./assets/portal/img/sede/sede_1.jpg"
                      className="img-fluid"
                      alt=""
                    />{" "}
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_5.jpg"
                      className="img-fluid"
                      alt=""
                    />
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_3.jpg"
                      className="img-fluid"
                      alt=""
                    />
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_4.jpg"
                      className="img-fluid"
                      alt=""
                    />
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_7.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div
                    className="col-lg-6 content"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <p>
                      Deberá tenerse en cuenta que el profesional fonoaudiólogo
                      que quiera ejercer la profesión en el ámbito asistencial,
                      oficial o privado habilitado; en el ámbito educativo,
                      oficial o privado; en el ámbito laboral, oficial o
                      privado; en consultorios privados o en el domicilio del
                      paciente; en establecimientos comerciales afines a su
                      actividad específica, en el ámbito de la Provincia de La
                      Pampa, deberá presentar su pedido de inscripción ante el
                      Colegio de Fonoaudiólogos, para lo que deberá:
                    </p>
                    <ul>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>Acreditar su identidad personal</span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Presentar Título Habilitante (Diploma y certificado
                          analítico) expedido por universidades nacionales,
                          públicas o privadas, o institutos de enseñanza
                          terciaria no universitaria, públicos o privados
                          oficialmente reconocidos
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Declarar su Domicilio Real y el que constituirá con
                          motivo del ejercicio profesional, que servirá a
                          efectos de su relación con el Colegio
                        </span>
                      </li>
                    </ul>
                    <p>
                      La matriculación en los términos antes expuestos, otorga
                      al profesional el derecho a prestar servicios a todas las
                      Obras Sociales con las cuales el Colegio suscriba
                      Convenios de prestaciones.
                    </p>
                    <p className="fst-italic">
                      “Es requisito indispensable para el ejercicio de la
                      profesión de Fonoaudiólogo en la Provincia, estar
                      inscripto en la matrícula cuyo registro, atención y
                      vigilancia son a cargo del Colegio.”(Capítulo II, art. 12,
                      Ley Nº 2558).
                    </p>
                    <p>
                      Para tramitar la inscripción en la matrícula, se deberá
                      presentar, sin excepción, TODA la documentación requerida,
                      en el orden que aquí se establece y fotocopias en tamaño
                      A4:
                    </p>
                    <ul>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Nota de Solicitud de Inscripción en la Matrícula
                          (Según Formulario adjunto)
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Fotocopia de DNI con domicilio real (1º y 2º pág.), y
                          cambio de domicilio si lo hubiese. En caso de no
                          figurar el domicilio actualizado en el documento,
                          presentar fotocopia comprobante Impuesto o Servicio
                          para certificar el mismo. De no poseer, presentar
                          Declaración Jurada realizada ante Policía
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          TITULO ORIGINAL legalizado por Ministerio del
                          Interior, por la Universidad o Ministeriode Educación
                          pertinente, para ser sellado en el Acto de
                          Matriculación con el número de matrícula que otorgue
                          el Colegio Profesional de Fonoaudiólogos de La Pampa.
                          El mismo será devuelto el mismo día de la
                          matriculación
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Fotocopia de Título Profesional autenticado por
                          Escribano Público
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>4 fotos Carnet 4 x 4 color ACTUALIZADAS</span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Copia comprobante de Depósito de Transferencia en
                          concepto de Arancel de Matriculación. Datos Cuenta
                          Bancaria: Cta. Cte. Nro. 100-01-441418/2 - CBU:
                          09303001 101000 44141828 - CUIT: 30-71151783/5
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Constancia de CBU expedida por el Banco de La Pampa,
                          de Caja de Ahorro o Cuenta Corriente titularidad del
                          profesional
                        </span>
                      </li>
                    </ul>
                    <p>
                      El valor de la inscripción para el año 2025 asciende a
                      $170000, y la Cuota Social mensual a $17000. Ambos valores
                      se actualizan anualmente en Asamblea Ordinaria.
                    </p>
                    <p>
                      Para la adhesión al Débito Automático de la Cuota Mensual
                      de Matriculación, es requisito indispensable contar con
                      cuenta bancaria en el Banco de La Pampa SEM. Para tal fin,
                      se debe adjuntar Planilla de Solicitud de Adhesión al DAS
                      y constancia de CBU emitida por el Banco. La cuenta deberá
                      ser la misma a la informada para el depósito de las
                      liquidaciones mensuales.
                    </p>
                    <button className="btn-get-started" type="button">
                      Descargar Solicitud
                    </button>{" "}
                    -{" "}
                    <button className="btn-get-started" type="button">
                      Descargar Das Adhesión
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "consultorio" && (
          <>
            {/* Consultorio Section */}
            <section id="consultorio" className="about section">
              <div className="container section-title" data-aos="fade-up">
                <h2>
                  Requisitos para trabajar en Consultorio
                  <br />
                </h2>
                <p>
                  Toda documentación para iniciar trámites, se reciben de 1 al
                  15 de cada mes sin excepción, con cita previa. Pasado ese
                  plazo, pasa al mes próximo.
                </p>
              </div>

              <div className="container">
                <div className="row gy-4">
                  <div
                    className="col-lg-6 position-relative align-self-start"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <img
                      src="./assets/portal/img/sede/sede_1.jpg"
                      className="img-fluid"
                      alt=""
                    />{" "}
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_5.jpg"
                      className="img-fluid"
                      alt=""
                    />
                    <br />
                    <br />
                    <img
                      src="./assets/portal/img/sede/sede_3.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div
                    className="col-lg-6 content"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <ul>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>Constancia de Inscripción ante AFIP</span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Constancia de Inscripción en el Impuesto a los
                          Ingresos Brutos
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Habilitación de Consultorio expedido por el Ministerio
                          de Salud de La Pampa, a nombre del matriculado
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Inscripción en Registro Nacional de Prestadores con el
                          número de matrícula de COFOLP
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Certificado de Ética Profesional extendido por el
                          Colegio (o por otro Colegio en caso de haber
                          pertenecido o pertenecer)
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>Constancia de seguro de mala praxis vigente</span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Libre de deuda expedido por el Área Contable de el
                          Colegio
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Declaración Jurada en donde el/la matriculado/a se
                          compromete a informar cambio de situación fiscal
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Declaración Jurada de conformidad para ingresar al
                          Listado de Prestador y trabajar con las Obras
                          Sociales, mutuales o prepagas con las que el Colegio
                          mantienen convenios
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Realizar capacitación de facturación por Obras Social
                          a cargo de el Colegio
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-check2-all"></i>{" "}
                        <span>
                          Aceptación y conformidad de mantener la permanencia en
                          el Listado de Prestadores que trabajan con Obras
                          Sociales por un mínimo de 6 meses
                        </span>
                      </li>
                    </ul>
                    <br />
                    <br />
                    <button className="btn-get-started" type="button">
                      Descargar Solicitud Inscripción Superintendencia
                    </button>
                    <br />
                    <br />
                    <button className="btn-get-started" type="button">
                      Descargar Solicitud Registro Nacional de Prestadores
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "ejercicio-profesional" && (
          <>
            {/* Ejercicio Profesional Section */}
            <section id="ejercicioprofesional" className="services section">
              <div className="container section-title" data-aos="fade-up">
                <h2>Ejercicio Profesional</h2>
                <p>
                  Aquí encontrará información sobre el ejercicio profesional.
                </p>
              </div>

              <div className="container">
                <div className="row gy-4">
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="service-item  position-relative">
                      <div className="icon">
                        <i className="fas fa-dollar"></i>
                      </div>
                      <a className="stretched-link" href="#">
                        Honorarios Mínimos Eticos
                      </a>
                      <p>Descargue el archivo del año actual.</p>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-certificate"></i>
                      </div>
                      <a className="stretched-link" href="#">
                        Código de Etica
                      </a>
                      <p>Descargue el archivo del código de ética vigente.</p>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-stamp"></i>
                      </div>
                      <a
                        className="stretched-link"
                        href="#"
                        onClick={() => setTabIndex("certificado-etica")}
                      >
                        Certificado de Etica
                      </a>
                      <p>Envíe una solicitud para obtener el certificado</p>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-newspaper"></i>
                      </div>
                      <a className="stretched-link" href="#">
                        Consentimiento Informado
                      </a>
                      <p>
                        Non et temporibus minus omnis sed dolor esse
                        consequatur. Cupiditate sed error ea fuga sit provident
                        adipisci neque.
                      </p>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-notes-medical"></i>
                      </div>
                      <a
                        className="stretched-link"
                        href="#"
                        onClick={() => setTabIndex("consultorio")}
                      >
                        Habilitación del Consultorio
                      </a>
                      <p>
                        Revise la documentación necesaria para habilitar su
                        consultorio.
                      </p>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-user"></i>
                      </div>
                      <a
                        className="stretched-link"
                        href="#"
                        onClick={() => setTabIndex("matriculacion")}
                      >
                        Matriculación
                      </a>
                      <p>Lea atentamente los requisitos para matricularse.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "certificado-etica" && (
          <>
            {/* Appointment Section */}
            <section
              id="etica"
              className="appointment section light-background"
            >
              <div className="container section-title" data-aos="fade-up">
                <h2>Solicitud de Certificado de Etica</h2>
                <p>
                  Complete el siguiente formulario para realizar la solucitud al
                  Colegio
                </p>
              </div>

              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <form
                  action="forms/appointment.php"
                  method="post"
                  className="php-email-form"
                >
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="Nombre Completo"
                        required
                      />
                    </div>
                    <div className="col-md-4 form-group mt-3 mt-md-0">
                      <select
                        name="tipodoc"
                        id="tipodoc"
                        className="form-select"
                        required
                      >
                        <option value="">Tipo de Documento</option>
                        <option value="Department 1">DNI</option>
                        <option value="Department 2">LE</option>
                        <option value="Department 3">LC</option>
                      </select>
                    </div>
                    <div className="col-md-4 form-group mt-3 mt-md-0">
                      <input
                        type="tel"
                        className="form-control"
                        name="numdoc"
                        id="numdoc"
                        placeholder="Número de Documento"
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input
                        type="text"
                        name="nummatricula"
                        className="form-control"
                        id="nummatricula"
                        placeholder="Número de Matrícula Profesional"
                        required
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <input
                        type="text"
                        onFocusCapture={(e) => (e.currentTarget.type = "date")}
                        name="fecmatriculacion"
                        className="form-control datepicker"
                        id="fecmatriculacion"
                        placeholder="Fecha Matriculación"
                        required
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Your Email"
                        required
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your appointment request has been sent successfully. Thank
                      you!
                    </div>
                    <div className="text-center">
                      <button type="submit">Enviar Solicitud</button>
                    </div>
                  </div>
                </form>
              </div>
            </section>
          </>
        )}

        {tabIndex === "profesionales" && (
          <div className="profesionales">
            {/* Modern Professionals Section */}
            <section
              id="profesionales"
              className="professionals section"
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                padding: "80px 0",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Elementos decorativos de fondo */}
              <div
                style={{
                  position: "absolute",
                  top: "-50px",
                  right: "-50px",
                  width: "300px",
                  height: "300px",
                  background:
                    "linear-gradient(135deg, rgba(71, 85, 105, 0.1), rgba(100, 116, 139, 0.1))",
                  borderRadius: "50%",
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "-100px",
                  left: "-100px",
                  width: "400px",
                  height: "400px",
                  background:
                    "linear-gradient(135deg, rgba(100, 116, 139, 0.1), rgba(51, 65, 85, 0.1))",
                  borderRadius: "50%",
                  zIndex: 1,
                }}
              />

              <div
                className="container"
                style={{ position: "relative", zIndex: 2 }}
              >
                {/* Título moderno */}
                <div className="row">
                  <div
                    className="col-lg-12 text-center mb-5"
                    data-aos="fade-up"
                  >
                    <h2
                      style={{
                        fontSize: "3rem",
                        fontWeight: "700",
                        color: "#1e293b",
                        marginBottom: "15px",
                        fontFamily: "'Poppins', sans-serif",
                        textShadow: "0 2px 10px rgba(71, 85, 105, 0.15)",
                      }}
                    >
                      Nuestros{" "}
                      <span
                        style={{
                          background:
                            "linear-gradient(135deg, #475569 0%, #64748b 50%, #94a3b8 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundClip: "text",
                        }}
                      >
                        Profesionales
                      </span>
                    </h2>
                    <p
                      style={{
                        fontSize: "1.2rem",
                        color: "#64748b",
                        maxWidth: "600px",
                        margin: "0 auto",
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Encuentra a nuestros profesionales matriculados
                      especializados en fonoaudiología
                    </p>
                  </div>
                </div>

                {/* Filtros modernos con glassmorphism */}
                <div
                  className="row mb-5"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="col-12">
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)",
                        backdropFilter: "blur(15px)",
                        borderRadius: "20px",
                        padding: "30px",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)",
                      }}
                    >
                      <div className="row g-3">
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-person me-2"
                              style={{ color: "#06b6d4" }}
                            ></i>
                            <i
                              className="bi bi-card-text me-2"
                              style={{ color: "#0ea5e9" }}
                            ></i>
                            Buscar por nombre o matrícula
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre o N° de matrícula"
                            value={filtroNombre}
                            onChange={(e) => setFiltroNombre(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(6, 182, 212, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              transition: "all 0.3s ease",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          />
                          <small
                            style={{
                              color: "#64748b",
                              fontSize: "0.8rem",
                              fontStyle: "italic",
                              marginTop: "4px",
                              display: "block",
                            }}
                          >
                            Ejemplo: "Juan" o "143"
                          </small>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-geo-alt me-2"
                              style={{ color: "#10b981" }}
                            ></i>
                            Localidad
                          </label>
                          <select
                            className="form-select"
                            value={filtroLocalidad}
                            onChange={(e) => setFiltroLocalidad(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(16, 185, 129, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todas las localidades</option>
                            {localidades.map((loc) => (
                              <option key={loc} value={loc}>
                                {loc}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-heart-pulse me-2"
                              style={{ color: "#14b8a6" }}
                            ></i>
                            Obra Social
                          </label>
                          <select
                            className="form-select"
                            value={filtroObraSocial}
                            onChange={(e) =>
                              setFiltroObraSocial(e.target.value)
                            }
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(20, 184, 166, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todos</option>
                            <option value="si">Atiende Obra Social</option>
                            <option value="no">No atiende Obra Social</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-bookmark me-2"
                              style={{ color: "#0ea5e9" }}
                            ></i>
                            Especialidad
                          </label>
                          <select
                            className="form-select"
                            value={filtroEspecialidad}
                            onChange={(e) =>
                              setFiltroEspecialidad(e.target.value)
                            }
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(14, 165, 233, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todas las especialidades</option>
                            {especialidades.map((esp) => (
                              <option key={esp} value={esp}>
                                {esp}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tabla moderna de profesionales */}
                <div className="row">
                  <div
                    className="col-12"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    {profesionalesFiltrados.length === 0 ? (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)",
                          backdropFilter: "blur(15px)",
                          borderRadius: "20px",
                          padding: "60px 40px",
                          border: "1px solid rgba(255, 255, 255, 0.3)",
                          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)",
                          textAlign: "center",
                        }}
                      >
                        <i
                          className="bi bi-search"
                          style={{
                            fontSize: "3rem",
                            color: "#94a3b8",
                            marginBottom: "20px",
                          }}
                        ></i>
                        <h4
                          style={{
                            color: "#64748b",
                            fontFamily: "'Poppins', sans-serif",
                            marginBottom: "10px",
                          }}
                        >
                          No se encontraron profesionales
                        </h4>
                        <p
                          style={{
                            color: "#94a3b8",
                            fontSize: "1rem",
                          }}
                        >
                          Intenta ajustar los filtros de búsqueda
                        </p>
                      </div>
                    ) : (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)",
                          backdropFilter: "blur(15px)",
                          borderRadius: "20px",
                          border: "1px solid rgba(255, 255, 255, 0.3)",
                          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)",
                          overflow: "hidden",
                        }}
                      >
                        {/* Header de tabla para escritorio */}
                        <div className="d-none d-lg-block">
                          <div
                            className="professional-table-header"
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "200px 200px 150px 120px 180px 120px 180px",
                              gap: "20px",
                              padding: "25px 30px",
                              background:
                                "linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(16, 185, 129, 0.05))",
                              borderBottom: "1px solid rgba(6, 182, 212, 0.2)",
                              fontFamily: "'Poppins', sans-serif",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-person-circle me-2"
                                style={{ color: "#06b6d4" }}
                              ></i>
                              Profesional
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-geo-alt me-2"
                                style={{ color: "#10b981" }}
                              ></i>
                              Consultorio
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-telephone me-2"
                                style={{ color: "#14b8a6" }}
                              ></i>
                              Teléfono
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-card-text me-2"
                                style={{ color: "#0ea5e9" }}
                              ></i>
                              Matrícula
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-bookmark me-2"
                                style={{ color: "#8b5cf6" }}
                              ></i>
                              Especialidades
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-heart-pulse me-2"
                                style={{ color: "#f59e0b" }}
                              ></i>
                              Obra Social
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-share me-2"
                                style={{ color: "#ef4444" }}
                              ></i>
                              Redes
                            </div>
                          </div>
                        </div>

                        {/* Filas de profesionales */}
                        <div>
                          {profesionalesFiltrados.map((profesional, idx) => (
                            <React.Fragment key={profesional.nombre + idx}>
                              {/* Vista de escritorio */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "200px 200px 150px 120px 180px 120px 180px",
                                  gap: "20px",
                                  padding: "20px 30px",
                                  borderBottom:
                                    idx < profesionalesFiltrados.length - 1
                                      ? "1px solid rgba(226, 232, 240, 0.6)"
                                      : "none",
                                  transition: "all 0.3s ease",
                                  fontFamily: "'Inter', sans-serif",
                                  fontSize: "0.9rem",
                                  alignItems: "center",
                                }}
                                className="professional-table-row d-none d-lg-grid"
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background =
                                    "rgba(6, 182, 212, 0.05)";
                                  e.currentTarget.style.transform =
                                    "translateX(5px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background =
                                    "transparent";
                                  e.currentTarget.style.transform =
                                    "translateX(0)";
                                }}
                              >
                                {/* Profesional */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      background:
                                        "linear-gradient(135deg, #06b6d4, #10b981)",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      boxShadow:
                                        "0 4px 15px rgba(6, 182, 212, 0.3)",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <i
                                      className="fas fa-user-md"
                                      style={{
                                        fontSize: "1.1rem",
                                        color: "white",
                                      }}
                                    ></i>
                                  </div>
                                  <div>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        color: "#1e293b",
                                        fontSize: "0.95rem",
                                        marginBottom: "2px",
                                        lineHeight: "1.2",
                                      }}
                                    >
                                      {profesional.nombre}
                                    </div>
                                    <div
                                      style={{
                                        color: "#64748b",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      {profesional.localidad}
                                    </div>
                                  </div>
                                </div>

                                {/* Consultorio */}
                                <div
                                  style={{
                                    color: "#64748b",
                                    lineHeight: "1.4",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  {profesional.consultorio}
                                </div>

                                {/* Teléfono */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <a
                                    href={`tel:${profesional.telefono}`}
                                    style={{
                                      color: "#06b6d4",
                                      textDecoration: "none",
                                      fontWeight: "500",
                                      transition: "color 0.2s ease",
                                      fontSize: "0.85rem",
                                      textAlign: "center",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.color = "#0891b2")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.color = "#06b6d4")
                                    }
                                  >
                                    {profesional.telefono}
                                  </a>
                                </div>

                                {/* Matrícula */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#64748b",
                                    fontWeight: "500",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  {profesional.matricula}
                                </div>

                                {/* Especialidades */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "4px",
                                    alignItems: "center",
                                  }}
                                >
                                  {profesional.especialidades
                                    .slice(0, 2)
                                    .map((esp) => (
                                      <span
                                        key={esp}
                                        style={{
                                          background:
                                            "linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(16, 185, 129, 0.1))",
                                          color: "#047857",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          fontSize: "0.7rem",
                                          fontWeight: "500",
                                          border:
                                            "1px solid rgba(6, 182, 212, 0.2)",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {esp}
                                      </span>
                                    ))}
                                  {profesional.especialidades.length > 2 && (
                                    <span
                                      style={{
                                        background: "rgba(100, 116, 139, 0.1)",
                                        color: "#64748b",
                                        padding: "2px 6px",
                                        borderRadius: "12px",
                                        fontSize: "0.65rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      +{profesional.especialidades.length - 2}
                                    </span>
                                  )}
                                </div>

                                {/* Obra Social */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {profesional.atiendeObraSocial ? (
                                    <div
                                      style={{
                                        background:
                                          "linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(34, 197, 94, 0.1))",
                                        color: "#10b981",
                                        padding: "4px 12px",
                                        borderRadius: "20px",
                                        fontSize: "0.75rem",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        border:
                                          "1px solid rgba(16, 185, 129, 0.2)",
                                      }}
                                    >
                                      <i className="bi bi-check-circle-fill"></i>
                                      Sí
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        background: "rgba(148, 163, 184, 0.1)",
                                        color: "#94a3b8",
                                        padding: "4px 12px",
                                        borderRadius: "20px",
                                        fontSize: "0.75rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      No
                                    </div>
                                  )}
                                </div>

                                {/* Redes sociales */}
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {profesional.redes.twitter && (
                                    <a
                                      href={profesional.redes.twitter}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background:
                                          "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                                        color: "white",
                                        textDecoration: "none",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <i
                                        className="bi bi-twitter-x"
                                        style={{ fontSize: "0.8rem" }}
                                      ></i>
                                    </a>
                                  )}
                                  {profesional.redes.facebook && (
                                    <a
                                      href={profesional.redes.facebook}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background:
                                          "linear-gradient(135deg, #3b5998, #2d4373)",
                                        color: "white",
                                        textDecoration: "none",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <i
                                        className="bi bi-facebook"
                                        style={{ fontSize: "0.8rem" }}
                                      ></i>
                                    </a>
                                  )}
                                  {profesional.redes.instagram && (
                                    <a
                                      href={profesional.redes.instagram}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background:
                                          "linear-gradient(135deg, #e4405f, #c13584)",
                                        color: "white",
                                        textDecoration: "none",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <i
                                        className="bi bi-instagram"
                                        style={{ fontSize: "0.8rem" }}
                                      ></i>
                                    </a>
                                  )}
                                  {profesional.redes.linkedin && (
                                    <a
                                      href={profesional.redes.linkedin}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background:
                                          "linear-gradient(135deg, #0077b5, #005885)",
                                        color: "white",
                                        textDecoration: "none",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <i
                                        className="bi bi-linkedin"
                                        style={{ fontSize: "0.8rem" }}
                                      ></i>
                                    </a>
                                  )}
                                </div>
                              </div>

                              {/* Vista móvil - Cards compactas */}
                              <div
                                className="d-lg-none"
                                style={{
                                  padding: "20px",
                                  borderBottom:
                                    idx < profesionalesFiltrados.length - 1
                                      ? "1px solid rgba(226, 232, 240, 0.6)"
                                      : "none",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "15px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      background:
                                        "linear-gradient(135deg, #06b6d4, #10b981)",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      boxShadow:
                                        "0 4px 15px rgba(6, 182, 212, 0.3)",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <i
                                      className="fas fa-user-md"
                                      style={{
                                        fontSize: "1.2rem",
                                        color: "white",
                                      }}
                                    ></i>
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <h5
                                      style={{
                                        fontWeight: "600",
                                        color: "#1e293b",
                                        margin: "0 0 5px 0",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      {profesional.nombre}
                                    </h5>
                                    <div
                                      style={{
                                        color: "#64748b",
                                        fontSize: "0.85rem",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <i
                                        className="bi bi-geo-alt-fill me-1"
                                        style={{ color: "#10b981" }}
                                      ></i>
                                      {profesional.consultorio}
                                    </div>
                                    <div
                                      style={{
                                        color: "#64748b",
                                        fontSize: "0.85rem",
                                      }}
                                    >
                                      <i
                                        className="bi bi-telephone-fill me-1"
                                        style={{ color: "#06b6d4" }}
                                      ></i>
                                      <a
                                        href={`tel:${profesional.telefono}`}
                                        style={{
                                          color: "#06b6d4",
                                          textDecoration: "none",
                                        }}
                                      >
                                        {profesional.telefono}
                                      </a>
                                      <span className="ms-3">
                                        <i
                                          className="bi bi-card-text me-1"
                                          style={{ color: "#14b8a6" }}
                                        ></i>
                                        Mat. {profesional.matricula}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Especialidades móvil */}
                                <div style={{ marginBottom: "12px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "5px",
                                    }}
                                  >
                                    {profesional.especialidades.map((esp) => (
                                      <span
                                        key={esp}
                                        style={{
                                          background:
                                            "linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(16, 185, 129, 0.1))",
                                          color: "#047857",
                                          padding: "3px 10px",
                                          borderRadius: "12px",
                                          fontSize: "0.75rem",
                                          fontWeight: "500",
                                          border:
                                            "1px solid rgba(6, 182, 212, 0.2)",
                                        }}
                                      >
                                        {esp}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                {/* Footer móvil */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    paddingTop: "12px",
                                    borderTop:
                                      "1px solid rgba(226, 232, 240, 0.6)",
                                  }}
                                >
                                  <div>
                                    {profesional.atiendeObraSocial ? (
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(34, 197, 94, 0.1))",
                                          color: "#10b981",
                                          padding: "4px 10px",
                                          borderRadius: "15px",
                                          fontSize: "0.7rem",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "3px",
                                          border:
                                            "1px solid rgba(16, 185, 129, 0.2)",
                                        }}
                                      >
                                        <i className="bi bi-check-circle-fill"></i>
                                        Obra Social
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          background:
                                            "rgba(148, 163, 184, 0.1)",
                                          color: "#94a3b8",
                                          padding: "4px 10px",
                                          borderRadius: "15px",
                                          fontSize: "0.7rem",
                                          fontWeight: "500",
                                        }}
                                      >
                                        Sin Obra Social
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                    }}
                                  >
                                    {profesional.redes.twitter && (
                                      <a
                                        href={profesional.redes.twitter}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                                          color: "white",
                                          textDecoration: "none",
                                        }}
                                      >
                                        <i
                                          className="bi bi-twitter-x"
                                          style={{ fontSize: "0.9rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.facebook && (
                                      <a
                                        href={profesional.redes.facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #3b5998, #2d4373)",
                                          color: "white",
                                          textDecoration: "none",
                                        }}
                                      >
                                        <i
                                          className="bi bi-facebook"
                                          style={{ fontSize: "0.9rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.instagram && (
                                      <a
                                        href={profesional.redes.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #e4405f, #c13584)",
                                          color: "white",
                                          textDecoration: "none",
                                        }}
                                      >
                                        <i
                                          className="bi bi-instagram"
                                          style={{ fontSize: "0.9rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.linkedin && (
                                      <a
                                        href={profesional.redes.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #0077b5, #005885)",
                                          color: "white",
                                          textDecoration: "none",
                                        }}
                                      >
                                        <i
                                          className="bi bi-linkedin"
                                          style={{ fontSize: "0.9rem" }}
                                        ></i>
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Estilos CSS */}
              <style>{`
                .form-control:focus, .form-select:focus {
                  border-color: #06b6d4 !important;
                  box-shadow: 0 0 0 0.2rem rgba(6, 182, 212, 0.25) !important;
                  outline: none;
                }
                
                .professional-table-row:hover .bi {
                  transform: scale(1.1);
                }
                
                @media (max-width: 768px) {
                  .professionals.section {
                    padding: 60px 0 !important;
                  }
                  
                  .professionals h2 {
                    font-size: 2.2rem !important;
                  }
                  
                  .professionals .col-12 div[style*="padding: 30px"] {
                    padding: 20px !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .professionals.section {
                    padding: 40px 0 !important;
                  }
                  
                  .professionals h2 {
                    font-size: 1.8rem !important;
                  }
                  
                  .professionals .col-12 div[style*="padding: 20px"] {
                    padding: 15px !important;
                  }
                }
                
                /* Animaciones para el footer */
                @keyframes footerGradientShift {
                  0% {
                    background-position: 0% 50%;
                  }
                  25% {
                    background-position: 50% 25%;
                  }
                  50% {
                    background-position: 100% 50%;
                  }
                  75% {
                    background-position: 50% 75%;
                  }
                  100% {
                    background-position: 0% 50%;
                  }
                }
                
                @keyframes footerPatternFloat {
                  0% {
                    transform: translateX(0) translateY(0) rotate(0deg);
                  }
                  25% {
                    transform: translateX(-15px) translateY(-20px) rotate(90deg);
                  }
                  50% {
                    transform: translateX(0) translateY(-40px) rotate(180deg);
                  }
                  75% {
                    transform: translateX(15px) translateY(-20px) rotate(270deg);
                  }
                  100% {
                    transform: translateX(0) translateY(0) rotate(360deg);
                  }
                }
                
                /* Footer responsive */
                @media (max-width: 768px) {
                  #footer {
                    padding-top: 40px !important;
                  }
                  
                  .footer-top {
                    padding-bottom: 30px !important;
                  }
                  
                  .footer-links h4 {
                    font-size: 1.1rem !important;
                    margin-bottom: 15px !important;
                  }
                  
                  .social-links a {
                    width: 35px !important;
                    height: 35px !important;
                    margin-right: 8px !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .footer-contact p {
                    font-size: 0.9rem !important;
                  }
                  
                  .footer-links ul li {
                    margin-bottom: 8px !important;
                  }
                  
                  .copyright p {
                    font-size: 0.85rem !important;
                  }
                }
              `}</style>
            </section>
          </div>
        )}

        {tabIndex === "tramites" && (
          <>
            {/* Faq Section */}
            <section id="tramites" className="faq section light-background">
              <div className="container section-title" data-aos="fade-up">
                <h2>Trámites</h2>
              </div>

              <div className="container">
                <div className="row justify-content-center">
                  <div
                    className="col-lg-10"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="faq-container">
                      <div className="faq-item">
                        <h3>Matriculación</h3>
                        <div className="faq-content">
                          <p>
                            Deberá tenerse en cuenta que el profesional
                            fonoaudiólogo que quiera ejercer la profesión en el
                            ámbito asistencial, oficial o privado habilitado; en
                            el ámbito educativo, oficial o privado; en el ámbito
                            laboral, oficial o privado; en consultorios privados
                            o en el domicilio del paciente; en establecimientos
                            comerciales afines a su actividad específica, en el
                            ámbito de la Provincia de La Pampa, deberá presentar
                            su pedido de inscripción ante el Colegio de
                            Fonoaudiólogos...
                            <a
                              href="#matriculacion"
                              className="btn-get-started"
                            >
                              {" "}
                              Consulte todos los requisitos
                            </a>
                          </p>
                        </div>
                        <i className="faq-toggle bi bi-chevron-right"></i>
                      </div>

                      <div className="faq-item">
                        <h3>Consultorio</h3>
                        <div className="faq-content">
                          <p>
                            Si usted va a trabajar en consultorio deberá
                            presentar toda documentación para iniciar los
                            siguientes trámites, se reciben de 1 al 15 de cada
                            mes sin excepción, con cita previa. Pasado ese
                            plazo, pasa al mes próximo.
                            <a href="#consultorio" className="btn-get-started">
                              {" "}
                              Ver documentación a presentar
                            </a>
                          </p>
                        </div>
                        <i className="faq-toggle bi bi-chevron-right"></i>
                      </div>

                      <div className="faq-item">
                        <h3>Incorporación de Título</h3>
                        <div className="faq-content">
                          <p>
                            Para el trámite incorporación de Título es necesario
                            completar la nota de Solicitud de Incorporación de
                            título y abonar el arancel equivalente a dos códigos
                            25.01.04
                            <a
                              href="#"
                              className="btn-get-started"
                              role="button"
                              tabIndex={0}
                              onClick={(e) => e.preventDefault()}
                            >
                              {" "}
                              Descargar Solicitud Incorporación de Título
                            </a>
                          </p>
                        </div>
                        <i className="faq-toggle bi bi-chevron-right"></i>
                      </div>

                      <div className="faq-item">
                        <h3>Requisitos para la baja de Matrícula</h3>
                        <div className="faq-content">
                          <p>
                            Si usted desea dar de baja su matrícula deberá
                            presentar toda documentación para iniciar el
                            trámite.
                            <a
                              href="#"
                              className="btn-get-started"
                              role="button"
                              tabIndex={0}
                              onClick={(e) => e.preventDefault()}
                            >
                              {" "}
                              Descargar Solicitud de Baja{" "}
                            </a>{" "}
                            -{" "}
                            <a
                              href="#"
                              className="btn-get-started"
                              role="button"
                              tabIndex={0}
                              onClick={(e) => e.preventDefault()}
                            >
                              {" "}
                              Descargar Declaración Jurada
                            </a>
                          </p>
                        </div>
                        <i className="faq-toggle bi bi-chevron-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "contacto" && (
          <>
            {/* Contact Section */}
            <section id="contact" className="contact section">
              <div className="container section-title" data-aos="fade-up">
                <h2>Contacto</h2>
              </div>

              <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                <iframe
                  style={{ border: 0, width: "100%", height: "370px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3432.055793259047!2d-64.28344972377954!3d-36.60962886618601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95c2cda2ffebeb1b%3A0xfa949b07b5275bc8!2sAv.%20Agust%C3%ADn%20Spinetto%20670%2C%20L6300%20Santa%20Rosa%2C%20La%20Pampa!5e1!3m2!1ses-419!2sar!4v1761251729059!5m2!1ses-419!2sar"
                  frameBorder="0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="row gy-4">
                  <div className="col-lg-6 ">
                    <div className="row gy-4">
                      <div className="col-lg-12">
                        <div
                          className="info-item d-flex flex-column justify-content-center align-items-center"
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <i className="bi bi-geo-alt"></i>
                          <h3>Domicilio</h3>
                          <p>
                            Avda. Spinetto 670 Dpto. 2 A, SANTA ROSA, La Pampa
                          </p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div
                          className="info-item d-flex flex-column justify-content-center align-items-center"
                          data-aos="fade-up"
                          data-aos-delay="300"
                        >
                          <i className="bi bi-telephone"></i>
                          <h3>Teléfonos</h3>
                          <p>02954 - 702284 (Sede)</p>
                          <p>2954 - 295396 (Móvil)</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div
                          className="info-item d-flex flex-column justify-content-center align-items-center"
                          data-aos="fade-up"
                          data-aos-delay="400"
                        >
                          <i className="bi bi-envelope"></i>
                          <h3>Email</h3>
                          <p>cofolp@gmail.com</p>
                          <p>asesoramiento-sei@googlegroups.com</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <form
                      action="forms/contact.php"
                      method="post"
                      className="php-email-form"
                      data-aos="fade-up"
                      data-aos-delay="500"
                    >
                      <div className="row gy-4">
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Nombre"
                            required
                          />
                        </div>

                        <div className="col-md-6 ">
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="Email"
                            required
                          />
                        </div>

                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            name="subject"
                            placeholder="Asunto"
                            required
                          />
                        </div>

                        <div className="col-md-12">
                          <textarea
                            className="form-control"
                            name="message"
                            rows={4}
                            placeholder="Consulta"
                            required
                          ></textarea>
                        </div>

                        <div className="col-md-12 text-center">
                          <div className="loading">Cargando</div>
                          <div className="error-message"></div>
                          <div className="sent-message">
                            Su mensaje ha sido enviado. Gracias!
                          </div>

                          <button type="submit">Enviar Mensaje</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </main>
      {/* FOOTER */}
      <footer
        id="footer"
        className="footer"
        style={{
          background:
            "linear-gradient(135deg, #1e293b 0%, #334155 25%, #475569 50%, #64748b 75%, #374151 100%)",
          backgroundSize: "400% 400%",
          animation: "footerGradientShift 20s ease infinite",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Elementos decorativos de fondo */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `
            radial-gradient(circle at 20% 30%, rgba(6, 182, 212, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(16, 185, 129, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(20, 184, 166, 0.05) 0%, transparent 50%)
          `,
            zIndex: 1,
          }}
        />

        {/* Patrón geométrico de fondo */}
        <div
          style={{
            position: "absolute",
            top: "-50%",
            left: "-50%",
            width: "200%",
            height: "200%",
            backgroundImage: `
            linear-gradient(45deg, rgba(255, 255, 255, 0.02) 25%, transparent 25%),
            linear-gradient(-45deg, rgba(255, 255, 255, 0.02) 25%, transparent 25%),
            linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.02) 75%),
            linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.02) 75%)
          `,
            backgroundSize: "80px 80px",
            backgroundPosition: "0 0, 0 40px, 40px -40px, -40px 0px",
            animation: "footerPatternFloat 25s linear infinite",
            zIndex: 2,
          }}
        />

        {/* Overlay con glassmorphism */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(51, 65, 85, 0.7) 100%)",
            backdropFilter: "blur(10px)",
            zIndex: 3,
          }}
        />

        <div
          className="container footer-top"
          style={{ position: "relative", zIndex: 4 }}
        >
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <a
                href="index.html"
                className="logo d-flex align-items-center"
                style={{
                  textDecoration: "none",
                  color: "#ffffff",
                }}
              >
                <span
                  className="sitename"
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    fontFamily: "'Poppins', sans-serif",
                    background: "linear-gradient(135deg, #06b6d4, #10b981)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textShadow: "0 2px 10px rgba(6, 182, 212, 0.3)",
                  }}
                >
                  Cofolp
                </span>
              </a>
              <div className="footer-contact pt-3">
                <p
                  style={{
                    color: "#cbd5e1",
                    marginBottom: "5px",
                    fontSize: "1rem",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  Av. Spinetto 670
                </p>
                <p
                  style={{
                    color: "#cbd5e1",
                    marginBottom: "15px",
                    fontSize: "1rem",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  Santa Rosa - La Pampa
                </p>
                <p
                  className="mt-3"
                  style={{
                    color: "#e2e8f0",
                    marginBottom: "8px",
                    fontSize: "0.95rem",
                  }}
                >
                  <strong style={{ color: "#06b6d4" }}>Teléfono:</strong>
                  <span style={{ marginLeft: "8px" }}>+54 2954 702284</span>
                </p>
                <p
                  style={{
                    color: "#e2e8f0",
                    fontSize: "0.95rem",
                  }}
                >
                  <strong style={{ color: "#10b981" }}>Email:</strong>
                  <span style={{ marginLeft: "8px" }}>cofolp@gmail.com</span>
                </p>
              </div>
              <div className="social-links d-flex mt-4">
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    marginRight: "10px",
                    boxShadow: "0 4px 15px rgba(29, 161, 242, 0.3)",
                  }}
                >
                  <i
                    className="bi bi-twitter-x"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #3b5998, #2d4373)",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    marginRight: "10px",
                    boxShadow: "0 4px 15px rgba(59, 89, 152, 0.3)",
                  }}
                >
                  <i
                    className="bi bi-facebook"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e4405f, #c13584)",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    marginRight: "10px",
                    boxShadow: "0 4px 15px rgba(228, 64, 95, 0.3)",
                  }}
                >
                  <i
                    className="bi bi-instagram"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #0077b5, #005885)",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(0, 119, 181, 0.3)",
                  }}
                >
                  <i
                    className="bi bi-linkedin"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4
                style={{
                  color: "#06b6d4",
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  marginBottom: "20px",
                  fontFamily: "'Poppins', sans-serif",
                  textShadow: "0 2px 8px rgba(6, 182, 212, 0.3)",
                }}
              >
                Links
              </h4>
              <ul style={{ listStyle: "none", padding: 0 }}>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("home")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#06b6d4";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Inicio
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("institucional")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#06b6d4";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Institucional
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("tramites")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#06b6d4";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Trámites
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("ejercicio-profesional")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#06b6d4";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Ejercicio Profesional
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("profesionales")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#06b6d4";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Profesionales
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4
                style={{
                  color: "#10b981",
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  marginBottom: "20px",
                  fontFamily: "'Poppins', sans-serif",
                  textShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
                }}
              >
                Ejercicio Profesional
              </h4>
              <ul style={{ listStyle: "none", padding: 0 }}>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#10b981";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Honorarios Mínimos
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#10b981";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Código de Etica
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("certificado-etica")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#10b981";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Certificado de Etica
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#10b981";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Consentimiento Informado
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4
                style={{
                  color: "#14b8a6",
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  marginBottom: "20px",
                  fontFamily: "'Poppins', sans-serif",
                  textShadow: "0 2px 8px rgba(20, 184, 166, 0.3)",
                }}
              >
                Trámites
              </h4>
              <ul style={{ listStyle: "none", padding: 0 }}>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("matriculacion")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#14b8a6";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Matriculación
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    onClick={() => setTabIndex("consultorio")}
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#14b8a6";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Consultorio
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#14b8a6";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Título
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="#"
                    style={{
                      color: "#cbd5e1",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "all 0.3s ease",
                      fontFamily: "'Inter', sans-serif",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "#14b8a6";
                      e.currentTarget.style.paddingLeft = "10px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "#cbd5e1";
                      e.currentTarget.style.paddingLeft = "0";
                    }}
                  >
                    <i
                      className="bi bi-chevron-right"
                      style={{ marginRight: "8px", fontSize: "0.8rem" }}
                    ></i>
                    Baja de Matrícula
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className="container copyright text-center mt-4"
          style={{ position: "relative", zIndex: 4 }}
        >
          <p
            style={{
              color: "#cbd5e1",
              fontSize: "0.9rem",
              marginBottom: "10px",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            © <span style={{ color: "#e2e8f0" }}>Copyright</span>{" "}
            <strong
              className="px-1 sitename"
              style={{
                background: "linear-gradient(135deg, #06b6d4, #10b981)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Cofolp
            </strong>{" "}
            <span style={{ color: "#e2e8f0" }}>
              Todos los derechos reservados
            </span>
          </p>
          <div className="credits"></div>
        </div>
      </footer>
      {/* Scroll Top */}
      <a
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
      {/* Preloader */}
      {/* <div id="preloader"></div> */}
    </>
  );
};

export default PortalHome;
